if (!customElements.get('product-quantity-total')) {
  customElements.define(
    'product-quantity-total',
    class ProductQuantityTotal extends HTMLElement {
      quantityUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.input = document.getElementById(`Quantity-${this.dataset.sectionId}`);
        this.output = this.querySelector('[data-quantity-total-value]');

        if (!this.input || !this.output) return;

        this.input.addEventListener('input', this.update);
        this.input.addEventListener('change', this.update);
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.update);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        this.update();
      }

      disconnectedCallback() {
        this.input?.removeEventListener('input', this.update);
        this.input?.removeEventListener('change', this.update);
        this.quantityUpdateUnsubscriber?.();
        this.variantChangeUnsubscriber?.();
      }

      onVariantChange = ({ data }) => {
        const productInfo = this.closest('product-info');
        const currentSectionId = productInfo?.dataset.originalSection || productInfo?.dataset.section;
        if (!data?.html || data.sectionId !== currentSectionId) return;

        const source = data.html.getElementById(`Quantity-Total-${data.sectionId}`);
        if (!source) return;

        ['unitPrice', 'compareAtPrice', 'currency', 'cartQuantity', 'priceBreaks'].forEach((key) => {
          if (source.dataset[key] === undefined) {
            delete this.dataset[key];
          } else {
            this.dataset[key] = source.dataset[key];
          }
        });

        this.update();
      };

      update = () => {
        if (!this.input || !this.output) return;

        const quantity = Math.max(0, Number.parseInt(this.input.value || '0', 10) || 0);
        const cartQuantity = Math.max(0, Number.parseInt(this.dataset.cartQuantity || '0', 10) || 0);
        let unitPrice = Math.max(0, Number.parseInt(this.dataset.unitPrice || '0', 10) || 0);

        try {
          const priceBreaks = JSON.parse(this.dataset.priceBreaks || '[]')
            .map((priceBreak) => ({
              minimumQuantity: Number(priceBreak.minimum_quantity || 0),
              price: Number(priceBreak.price || 0),
            }))
            .filter((priceBreak) => priceBreak.minimumQuantity > 0 && priceBreak.price >= 0)
            .sort((a, b) => b.minimumQuantity - a.minimumQuantity);
          const applicableBreak = priceBreaks.find(
            (priceBreak) => cartQuantity + quantity >= priceBreak.minimumQuantity
          );
          if (applicableBreak) unitPrice = applicableBreak.price;
        } catch (_error) {
          // Keep the base variant price when volume pricing data is unavailable.
        }

        const currency = this.dataset.currency || 'USD';
        const formattedTotal = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency,
          currencyDisplay: 'narrowSymbol',
        }).format((unitPrice * quantity) / 100);

        this.output.textContent = `${formattedTotal} ${currency}`;
      };
    }
  );
}

